import React from 'react'
import styles from './CommunityCards.module.css';
// import GameCard from '../GameCard/GameCard';
import { GameCard } from '@themed-components';
import useCommunityCards from '@/src/hooks/data/useCommunityCards';
import useRITCommunityCards from '@/src/hooks/data/useRITCommunityCards';
import useGameStage from '@/src/hooks/data/useGameStage';
import { COMMUNITY_CARDS, M_CARD } from '@/Poker/data/Constants';
import { motion } from 'motion/react';

export default function CommunityCards({ tempTableId }) {
    const communityCards = useCommunityCards(tempTableId)
    const RITCommunityCards = useRITCommunityCards(tempTableId)
    const gameStage = useGameStage(tempTableId);

    if (!communityCards || communityCards.length === 0) return null;

    const isFullSecondRun = RITCommunityCards && RITCommunityCards.length === 5 && RITCommunityCards.every((card) => card && card !== 'cardBack');

    return (
        <div className={styles.communityCardsContainer}>
            <motion.div
                animate={{
                    y: isFullSecondRun ? -10 : 0,
                    scale: isFullSecondRun ? 0.8 : 1,
                }}
                className={styles.communityCards}>
                {communityCards && communityCards.map((card, index) => {
                    const shouldLift = !isFullSecondRun && RITCommunityCards && RITCommunityCards.length > 0 && RITCommunityCards[index] && RITCommunityCards[index] !== 'cardBack';
                    return card.source ? null : (
                        <motion.div key={index} animate={{ y: shouldLift ? -15 : 0 }}>
                            <GameCard size={M_CARD} index={index} gameStage={gameStage} type={COMMUNITY_CARDS} tempTableId={tempTableId} value={card} />
                        </motion.div>
                    )
                })}
            </motion.div>
            {
                RITCommunityCards && RITCommunityCards.length > 0 && (
                    <div className={styles.secondCommunityCardsRow}>
                        {RITCommunityCards && RITCommunityCards.map((card, index) => (
                            card.source ? null : <GameCard index={index} gameStage={gameStage} type={COMMUNITY_CARDS} tempTableId={tempTableId} key={index} value={card} />
                        ))}
                    </div>
                )
            }
        </div>
    )
}
